import React from "react";
import { usePrivacy } from "@/context/PrivacyContext";
import { money } from "@/lib/api";

/**
 * Renders a monetary value. When privacy toggle is ON, shows blurred dots.
 * Usage: <Money v={123.45} />
 */
export default function Money({ v, className = "" }) {
  const { hidden } = usePrivacy();
  if (hidden) {
    return <span className={`select-none tracking-widest ${className}`} aria-label="valor oculto">R$ ••••</span>;
  }
  return <span className={className}>{money(v)}</span>;
}

export function PrivacyToggle({ className = "" }) {
  const { hidden, toggle } = usePrivacy();
  return (
    <button
      data-testid="btn-toggle-privacy"
      onClick={toggle}
      aria-label={hidden ? "Mostrar valores" : "Esconder valores"}
      className={`w-10 h-10 rounded-full flex items-center justify-center border border-stone-200 bg-white text-stone-700 hover:text-[color:var(--terracotta)] transition-colors ${className}`}
    >
      {hidden ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" y1="2" x2="22" y2="22"/></svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>
      )}
    </button>
  );
}
